import { Component } from './component';

export interface DropdownProps {
  options: string[] | { value: string; label: string }[];
  onChange?: (value: string) => void;
  value?: string;
}

export class Dropdown extends Component {
  public el: HTMLSelectElement;

  constructor(props: DropdownProps) {
    super();

    this.el = document.createElement('select');

    for (const option of props.options) {
      const optionEl = document.createElement('option');
      if (typeof option === 'string') {
        optionEl.value = option;
        optionEl.appendChild(document.createTextNode(option));
      } else {
        optionEl.value = option.value;
        optionEl.appendChild(document.createTextNode(option.label));
      }

      if (props.value && optionEl.value === props.value) {
        optionEl.selected = true;
      }

      this.el.appendChild(optionEl);
    }

    this.el.addEventListener('change', () => {
      if (props.onChange) {
        props.onChange(this.el.value);
      }
    });
  }

  getValue(): string {
    return this.el.value;
  }

  setValue(value: string) {
    this.el.value = value;
  }
}
